// 端点ID常量类
export class EndpointID { }
EndpointID.loginWidget = "loginWidget"; // login widget
EndpointID.homeWidget = "homeWidget"; // 主页
EndpointID.routePrefix = "route:"; // 路由sid前缀
EndpointID.menusPrefix = "menus:"; // 菜单前缀
EndpointID.conversationListItem = "conversationList.item"; // 最近会话列表的item
EndpointID.showConversation = "showConversation"; // 显示会话页面
EndpointID.clearChannelMessages = "clearChannelMessages"; // 清空某个频道消息
EndpointID.emojiService = "emojiService"; // emoji服务

// 端点分类常量类
export class EndpointCategory { }
EndpointCategory.routes = "routes"; // 路由
EndpointCategory.menus = "menus"; // 菜单
EndpointCategory.channelSetting = "channelSetting"; // 频道设置
EndpointCategory.userInfo = "userInfo"; // 用户信息
EndpointCategory.channelManage = "channelManage"; // 频道管理
EndpointCategory.contactsHeader = "contactsHeader";
EndpointCategory.messageContextMenus = "messageContextMenus"; // 消息上下文菜单
EndpointCategory.friendApplyDataChange = "friendApplyDataChange"; // 好友申请数据改变
EndpointCategory.chatMenusPopover = "chatMenusPopover"; // 聊天菜单气泡
EndpointCategory.chatToolbars = "chatToolbars"; // 聊天工具栏
EndpointCategory.channelHeaderRightItems = "channelHeaderRightItems"; // 频道头部右侧items
EndpointCategory.organizational = "organizational"; // 组织架构
EndpointCategory.organizationalLayer = "organizationalLayer"; // 组织架构弹框

// 群组角色常量类
export class GroupRole { }
GroupRole.normal = 0; // 普通
GroupRole.owner = 1; // 群主
GroupRole.manager = 2; // 管理员

// 订阅者状态常量类
export class SubscriberStatus { }
SubscriberStatus.unknown = 0; // 未知
SubscriberStatus.normal = 1; // 正常
SubscriberStatus.blacklist = 2; // 黑名单

// 消息内容类型常量类
export class MessageContentTypeConst { }
MessageContentTypeConst.historySplit = -3; // 历史风格线
MessageContentTypeConst.typing = -2; // 输入中
MessageContentTypeConst.time = -1; // 时间消息
MessageContentTypeConst.image = 2; // 图片消息
MessageContentTypeConst.gif = 3; // gif消息
MessageContentTypeConst.voice = 4; // 语音消息
MessageContentTypeConst.smallVideo = 5; // 小视频
MessageContentTypeConst.location = 6; // 位置信息
MessageContentTypeConst.card = 7; // 名片
MessageContentTypeConst.file = 8; // 文件
MessageContentTypeConst.mergeForward = 11; // 合并转发
MessageContentTypeConst.lottieSticker = 12; // lottie贴图
MessageContentTypeConst.lottieEmojiSticker = 13; // lottie emoji 贴图
MessageContentTypeConst.joinOrganization = 16; // 加入组织
MessageContentTypeConst.addMembers = 1002; // 添加群成员
MessageContentTypeConst.removeMembers = 1003; // 删除群成员
MessageContentTypeConst.channelUpdate = 1005; // 频道更新
MessageContentTypeConst.newGroupOwner = 1008; // 成为新群主
MessageContentTypeConst.screenshot = 1014; // 截屏消息

// 音频通话消息号段 9900 - 9999
MessageContentTypeConst.rtcResult = 9989; // 音视频通话结果
MessageContentTypeConst.rtcSwitchToVideo = 9990; // 切换到视频通话
MessageContentTypeConst.rtcSwitchToVideoReply = 9991; // 切换到视频回复
MessageContentTypeConst.rtcCancel = 9992; // 取消通话
MessageContentTypeConst.rtcSwitchToAudio = 9993; // 音视频切换（未接通时）
MessageContentTypeConst.rtcData = 9994; // rtc信令数据类型
MessageContentTypeConst.rtcMissed = 9995; //  未接听
MessageContentTypeConst.rtcReceived = 9996; //  收到通话
MessageContentTypeConst.rtcRefue = 9997; // 拒绝通话
MessageContentTypeConst.rtcAccept = 9998; // 接受通话
MessageContentTypeConst.rtcHangup = 9999; // 挂断通话

// 用户关系常量类
export class UserRelation { }
UserRelation.stranger = 0; // 陌生人
UserRelation.friend = 1; // 好友
UserRelation.blacklist = 2; // 拉黑

// 网页端暂不支持的消息
export const unsupportMessageTypes = [];

// 消息结果码枚举（TS enum → JS对象，值与原枚举索引完全一致）
export const MessageReasonCode = {
    // ReasonUnknown 未知错误
    reasonUnknown: 0,
    // ReasonSuccess 成功
    reasonSuccess: 1,
    // ReasonAuthFail 认证失败
    reasonAuthFail: 2,
    // ReasonSubscriberNotExist 订阅者在频道内不存在
    reasonSubscriberNotExist: 3,
    // ReasonInBlacklist 在黑名单列表里
    reasonInBlacklist: 4,
    // ReasonChannelNotExist 频道不存在
    reasonChannelNotExist: 5,
    // ReasonUserNotOnNode 用户没在节点上
    reasonUserNotOnNode: 6,
    // ReasonSenderOffline // 发送者离线了，这条消息将发不成功
    reasonSenderOffline: 7,
    // ReasonMsgKeyError 消息key错误 说明消息不合法
    reasonMsgKeyError: 8,
    // ReasonPayloadDecodeError payload解码失败
    reasonPayloadDecodeError: 9,
    // ReasonForwardSendPacketError 转发发送包失败
    reasonForwardSendPacketError: 10,
    // ReasonNotAllowSend 不允许发送消息
    reasonNotAllowSend: 11,
    // ReasonConnectKick 连接被踢
    reasonConnectKick: 12,
    // ReasonNotInWhitelist 没在白名单内
    reasonNotInWhitelist: 13,
    // 查询用户token错误
    reasonQueryTokenError: 14,
    // 系统错误
    reasonSystemError: 15,
    // ReasonError
    reasonError: 16
};

// 排序因子
export const OrderFactor = 10000;

// 客服频道类型
export const ChannelTypeCustomerService = 3;